import { ReportsLandingComponent } from './reports-landing.component';
import { ReportsSchoolSearchComponent } from './reports-school-search.component';
import { ReportsSchoolSearchResultsComponent } from './reports-school-searchresults.component';
import { ReportsSchoolSearchResultsRowComponent } from './reports-school-searchresults-row.component';

export const components: any[] = [
  ReportsLandingComponent,
  ReportsSchoolSearchComponent,
  ReportsSchoolSearchResultsComponent,
  ReportsSchoolSearchResultsRowComponent
];

export * from './reports-landing.component';
export * from './reports-school-search.component';
export * from './reports-school-searchresults.component';
export * from './reports-school-searchresults-row.component';
